import { groupBy, sortBy, toPairs } from "lodash-es";
import { type AddressItem } from "$/utils/fetchGeoData";

export const sortByFirstChar = (
  arr: AddressItem[] | undefined,
  residenceCountry?: string,
) => {
  if (!arr) {
    return [];
  }

  const res1 = arr.map((it) => ({
    ...it,
    firstChat: it.spell?.[0]?.toUpperCase(),
  }));

  const res2 = sortBy(
    toPairs(
      groupBy(res1, (x) =>
        residenceCountry === "jpn"
          ? getVowelGroupFromKatakana(x.spell)
          : x.firstChat,
      ),
    ),
    (x) => x[0],
  );

  return res2.map(([letter, list]) => ({
    label: letter,
    children: list.sort((a, b) => {
      if (!a?.spell || !b?.spell) {
        return 0;
      }

      return a.spell > b.spell ? 1 : a.spell < b.spell ? -1 : 0;
    }),
  }));
};

export const getVowelGroupFromKatakana = (reading?: string): string => {
  const firstChar = reading?.[0] || "";

  const Row1 = "あアいイうウえエおオ";
  const Row2 = "かカきキくクけケこコがガぎギぐグげゲごゴ";
  const Row3 = "さサしシすスせセそソざザじジずズぜゼぞゾ";
  const Row4 = "たタちチつツてテとトだダぢヂづヅでデどド";
  const Row5 = "なナにニぬヌねネのノ";
  const Row6 = "はハひヒふフへヘほホばバびビぶブべベぼボ";
  const Row7 = "まマみミむムめメもモ";
  const Row8 = "やヤゆユよヨ";
  const Row9 = "らラりリるルれレろロ";
  const Row10 = "わワをヲ";

  if (Row1.includes(firstChar)) return "あ";
  if (Row2.includes(firstChar)) return "か";
  if (Row3.includes(firstChar)) return "さ";
  if (Row4.includes(firstChar)) return "た";
  if (Row5.includes(firstChar)) return "な";
  if (Row6.includes(firstChar)) return "は";
  if (Row7.includes(firstChar)) return "ま";
  if (Row8.includes(firstChar)) return "や";
  if (Row9.includes(firstChar)) return "ら";
  if (Row10.includes(firstChar)) return "わ";
  // 促音/长音起头：递归看后面
  return "#";
};
